export default "__VITE_ASSET__CaaD9JnW__"